
var cache = {sections: {}, dataReady: undefined};
function prepareCache (instance) {
	if (cache.dataReady === undefined) {
		cache.dataReady = false;
		instance.$http.get('backend://section').then(function (result) {
			var newSections = {};
			for (var i = 0; i < result.body.items.length; i++) {
				var item = result.body.items[i];
				newSections[item.id] = item;
			}
			cache.sections = newSections;
			cache.dataReady = true;
		});
	}
}
function updateCache (instance) {
	cache.dataReady = undefined;
	prepareCache(instance);
}

module.exports = {
	data: cache,
	prepare: prepareCache,
	update: updateCache
};



// WEBPACK FOOTER //
// ./src/components/forum/section-cache.js